import { useStableCallback } from '@ipfabric/ui-components/hooks/useStableCallback';
import { useNotifications } from 'utils/hooks/useNotifications';
import { assignLabels } from '../assignedLabelsApi';
import { mapSelectedTargetsToApi } from '../mapSelectedTargetsToApi';
import type { AssignLabelsFormSchemaValues } from './assignLabelsFormSchema';

type UseAssignLabelsSubmitParams = {
  snapshotId: string;
  onSaved: () => void;
};

export const useAssignLabelsSubmit = ({
  snapshotId,
  onSaved,
}: UseAssignLabelsSubmitParams) => {
  const { showNotification } = useNotifications();

  return useStableCallback(async (values: AssignLabelsFormSchemaValues) => {
    await assignLabels(
      snapshotId,
      values.labels,
      mapSelectedTargetsToApi(values.targets),
      values.inherit,
      values.reflectToRules,
    );
    showNotification({
      type: 'success',
      message: 'Labels assigned',
    });
    onSaved();
  });
};
